import * as yup from 'yup';

export const getChooseLoginSchema = yup.object().shape({
  userType: yup.string().required('Veuillez sélectionner une proposition.'),
});
